module.exports = __webpack_public_path__ + "img/logo-um-fnm.e33f3842.png";